export default __webpack_public_path__ + "static/gaming_journey_2-b57ccb02ac23b8e1ba3cb617d5554d3f.png";